// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress__AH+gn","circle":"circle__z9tfK","completed":"completed__tE5KB","in-progress":"in-progress__ZFjaq","not-started":"not-started__KAaE0"};